import { LOGIN_TOKEN, REMEMBER_ME, EMAIL, PASSWORD, LOCAL_STORE_DATA } from 'redux/actions/action_types';

const INTIAL_STATE = {
    urlObject: '',
}

export default (state = INTIAL_STATE, action) => {
    if (state === undefined) {
        state = null;
    }
    if (state === undefined) {
        state = null;
    }
    switch (action.type) {
        case LOGIN_TOKEN: {
            return { ...state, token: action.payload }
        }
        case REMEMBER_ME: {
            return { ...state, rememberMe: action.payload }
        }  
        case EMAIL: {
            return { ...state, email: action.payload }
        }    
        case PASSWORD: {
            return { ...state, password: action.payload }
        }  
        case LOCAL_STORE_DATA: {
            return { ...state, payload: action.payload }
        }               
        default:
            return state;
    }
}